import Observer from '@researchgate/react-intersection-observer';

interface ObserverProps {
  handleIntersecting: () => void;
}

export const PartiallyRestrictedObserver = ({
  handleIntersecting,
}: ObserverProps) => {
  const handleIntersectionChange = (event) => {
    if (event.isIntersecting) {
      handleIntersecting();
    }
  };
  return (
    <Observer onChange={handleIntersectionChange}>
      <tr></tr>
    </Observer>
  );
};
